import React, { useRef, useEffect } from "react";
import { socket } from "../../../../../socket/socketClient";

const DynamicTasksField = ({
	name,
	label,
	values,
	setFieldValue,
	meetingId,
}) => {
	const inputRefs = useRef([]);

	useEffect(() => {
		if (inputRefs.current.length > 0) {
			const lastIndex = inputRefs.current.length - 1;
			inputRefs.current[lastIndex]?.focus();
		}
	}, [values.length]);

	useEffect(() => {
		inputRefs.current = inputRefs.current.slice(0, values.length);
	}, [values.length]);

	const emitFieldUpdate = (updatedValues) => {
		setFieldValue(name, updatedValues);
		if (socket.connected && meetingId) {
			socket.emit("update_meeting_field", {
				meetingId,
				field: name,
				value: updatedValues,
			});
		}
	};

	const handleChange = (index, value) => {
		const updated = [...values];
		updated[index] = value;
		emitFieldUpdate(updated);
	};

	const handleAdd = () => {
		const updated = [...values, ""];
		emitFieldUpdate(updated);
	};

	const handleRemove = (index) => {
		const updated = values?.filter((_, i) => i !== index);
		emitFieldUpdate(updated);
		inputRefs.current.splice(index, 1);
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Enter") {
			e.preventDefault();
			if (values[index].trim() !== "") {
				handleAdd();
			}
		}
	};

	return (
		<div className="w-full">
			<label className="font-bold text-black mb-2 block">{label}</label>
			{values?.map((task, index) => (
				<div key={index} className="flex items-center mb-2">
					<input
						ref={(el) => (inputRefs.current[index] = el)}
						type="text"
						value={task}
						onChange={(e) => handleChange(index, e.target.value)}
						onKeyDown={(e) => handleKeyDown(e, index)}
						className="flex-grow p-2 border-2 border-black rounded-lg mr-2 focus:border-red-500"
						placeholder={`#${index + 1}`}
					/>
					<button
						type="button"
						onClick={() => handleRemove(index)}
						className="text-red-600 font-bold"
						disabled={values?.length === 1}
					>
						✕
					</button>
				</div>
			))}
			<button
				type="button"
				onClick={handleAdd}
				className="mt-2 text-blue-600 hover:underline text-sm"
			>
				+ Añadir
			</button>
		</div>
	);
};

export default DynamicTasksField;
